/* ZYVO Landingpages
   - [data-zv-buy]: scrollt zum Angebot (#zv-offer) und wählt optional eine Stufe (data-zv-bundle)
   - [data-zv-scroll]: scrollt sanft zum Anker im href (z. B. Sterne im Hero -> #zv-reviews)
   - [data-zv-countdown]: Restzeit der Aktion aus dem Hero (<html data-zv-promo-end, data-zv-promo-label>); "boxes" = Tage/Std/Min/Sek-Kästchen.
     Läuft echt ab: danach verschwinden alle [data-zv-promo]-Elemente, es gibt keinen Neustart. */
(function () {
  // Abstand für die mitlaufende Kopfzeile (Ankündigungsleiste + Header)
  function headerOffset() {
    var h = document.querySelector('store-header, .header');
    var bottom = h ? h.getBoundingClientRect().bottom : 0;
    return Math.max(0, bottom) + 12;
  }
  function scrollToEl(el) {
    window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - headerOffset(), behavior: 'smooth' });
  }
  function offerTarget() {
    return document.getElementById('zv-offer') ||
      document.querySelector('kaching-bundles-block, .kaching-bundles') ||
      document.querySelector('.product-form, form[action*="/cart/add"]');
  }
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-zv-scroll]');
    if (link) {
      var id = (link.getAttribute('href') || '').split('#')[1];
      var el = id && document.getElementById(id);
      if (el) { e.preventDefault(); scrollToEl(el); if (history.replaceState) history.replaceState(null, '', '#' + id); }
      return;
    }
    var btn = e.target.closest('[data-zv-buy]');
    if (!btn) return;
    var t = offerTarget();
    if (!t) return;
    e.preventDefault();
    var tier = parseInt(btn.getAttribute('data-zv-bundle') || '0', 10);
    if (tier > 0) document.dispatchEvent(new CustomEvent('zv:select-tier', { detail: { index: tier - 1 } }));
    scrollToEl(t);
  });

  // Aktions-Countdown
  var root = document.documentElement;
  var end = Date.parse(root.getAttribute('data-zv-promo-end') || '');
  var name = root.getAttribute('data-zv-promo-label') || 'Aktion';
  Array.prototype.forEach.call(document.querySelectorAll('span[data-zv-promo-name]'), function (el) { el.textContent = name; });
  if (!isNaN(end)) {
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var timer;
    var tick = function () {
      var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
      var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), m = Math.floor(left % 3600 / 60), s = left % 60;
      Array.prototype.forEach.call(document.querySelectorAll('[data-zv-countdown]'), function (el) {
        if (el.getAttribute('data-zv-countdown') === 'boxes') {
          var u = { d: d, h: h, m: m, s: s };
          Array.prototype.forEach.call(el.querySelectorAll('[data-u]'), function (b) { b.textContent = pad(u[b.getAttribute('data-u')]); });
        } else {
          el.textContent = (d ? d + (d === 1 ? ' Tag ' : ' Tagen ') : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
        }
      });
      if (!left) { root.classList.remove('zv-promo-live'); clearInterval(timer); }
    };
    tick();
    root.classList.add('zv-cd-ready');
    timer = setInterval(tick, 1000);
  }
})();
